import React, { useState } from "react";
import axios from "axios";
import { Bell, Check } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";
import { trackEvent } from "../lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ComingSoonSignup({ gameId, gameTitle }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!email.includes("@")) {
      toast({ title: "Hold on", description: "Please enter a valid email address." });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/notify`, { email: email.trim(), game: gameId });
      setDone(true);
      trackEvent("sign_up", { method: "coming-soon", game_id: gameId });
      toast({ title: `You're on the list! \ud83c\udf89`, description: `We'll email you when ${gameTitle} launches.` });
      setEmail("");
      setTimeout(() => setDone(false), 3500);
    } catch (err) {
      toast({ title: "Oops", description: "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-5 flex flex-col sm:flex-row gap-2">
      <Input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        className="h-11 rounded-full bg-white/10 border-white/15 text-white placeholder:text-white/40 focus-visible:ring-cyan-500"
      />
      <Button
        type="submit"
        disabled={loading}
        className="h-11 rounded-full bg-teal-600 hover:bg-teal-700 text-white font-semibold px-5 shrink-0"
      >
        {done ? <><Check className="w-4 h-4 mr-1" /> Added</> : <><Bell className="w-4 h-4 mr-1.5" /> Notify me</>}
      </Button>
    </form>
  );
}
